const CACHE_PREFIX = "instaport-admin-page-cache-v1:";
const MAX_STALE_AGE_MS = 24 * 60 * 60 * 1000;

const now = () => Date.now();

const readCacheRecord = (storage, key) => {
  if (!storage || !key) return null;

  try {
    const raw = storage.getItem(`${CACHE_PREFIX}${key}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const readAdminPageCache = (key, maxAgeMs = 5 * 60 * 1000) => {
  if (!key) return null;
  if (
    typeof sessionStorage === "undefined" &&
    typeof localStorage === "undefined"
  ) {
    return null;
  }

  try {
    const parsed =
      readCacheRecord(sessionStorage, key) || readCacheRecord(localStorage, key);
    if (!parsed) return null;

    const cachedAt = Number(parsed.cachedAt || 0);
    if (!cachedAt || now() - cachedAt > maxAgeMs) {
      if (now() - cachedAt > MAX_STALE_AGE_MS) {
        sessionStorage?.removeItem?.(`${CACHE_PREFIX}${key}`);
        localStorage?.removeItem?.(`${CACHE_PREFIX}${key}`);
        return null;
      }

      return parsed.data ?? null;
    }

    return parsed.data ?? null;
  } catch (error) {
    return null;
  }
};

export const writeAdminPageCache = (key, data) => {
  if (!key) return;
  if (
    typeof sessionStorage === "undefined" &&
    typeof localStorage === "undefined"
  ) {
    return;
  }

  try {
    const payload = JSON.stringify({
      cachedAt: now(),
      data,
    });
    sessionStorage?.setItem?.(`${CACHE_PREFIX}${key}`, payload);
    localStorage?.setItem?.(`${CACHE_PREFIX}${key}`, payload);
  } catch (error) {
    // Ignore storage quota / serialization issues and fall back to network only.
  }
};
